module.exports = __webpack_public_path__ + "media/img/event/logo/cardiff-473dc3f6dc7041024833fc6ec40be687.jpg";